import { render, staticRenderFns } from "./StudentCode.vue?vue&type=template&id=217aa062&scoped=true"
import script from "./StudentCode.vue?vue&type=script&lang=js"
export * from "./StudentCode.vue?vue&type=script&lang=js"
import style0 from "./StudentCode.vue?vue&type=style&index=0&id=217aa062&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "217aa062",
  null
  
)

export default component.exports